export const typography = {
  fonts: {
    body: `Poppins, sans-serif`,
    heading: `Poppins, sans-serif`,
  },
  fontSizes: {
    desktop: {
      h1: `4rem`,
      h2: `3rem`,
      h3: `2rem`,
      h4: `1.75rem`,
      h5: `1.5rem`,
      h6: `1.25rem`,
    },
    mobile: {
      h1: `2rem`,
      h2: `1.75rem`,
      h3: `1.5rem`,
      h4: `1.25rem`,
    },
    text: {
      1: `1.25rem`,
      2: `1.125rem`,
      3: `1rem`,
      4: `0.875rem`,
      5: `0.75rem`,
    },
  },
};
